import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-common-date-filter',
  templateUrl: './common-date-filter.component.html',
  styleUrls: ['./common-date-filter.component.scss']
})
export class CommonDateFilterComponent implements OnInit {
  constructor(private formBuilder: FormBuilder) {
    this.createForm();
  }
  @Output() filterDate: EventEmitter<any> = new EventEmitter<any>();
  filterForm!: FormGroup;
  day: any = 'year';
  someDate: Date = new Date('2021');
  from: FormControl = new FormControl('');
  to: FormControl = new FormControl('');
  ngOnInit(): void {
  }

  createForm(): void {
    this.filterForm = this.formBuilder.group({
      from: [''],
      to: [''],
      isMonth: [false]
    });
  }
  datePickerEventHandler(type: 'from' | 'to'): void {
    switch (type) {
      case 'from':
        const fromValue = moment(this.from.value).format('YYYY-MM-DD');
        this.from.setValue(fromValue);
        this.filterForm.controls.from.setValue(fromValue);
        this.filterForm.controls.to.setValue(null);
        break;
      case 'to':
        const toValue = moment(this.to.value).format('YYYY-MM-DD');
        this.to.setValue(toValue);
        this.filterForm.controls.to.setValue(toValue);
        break;
    }
  }
  setMonth(day: string): void {
    this.day = day;
    const today = moment(); // Get current date
    const startOfMonth = today.startOf('month').format('YYYY-MM-DD'); // Start of current month
    const endOfMonth = today.endOf('month').format('YYYY-MM-DD'); // End of current month
    this.from.setValue(startOfMonth);
    this.to.setValue(endOfMonth);
    this.filterForm.patchValue({
      from: startOfMonth,
      to: endOfMonth,
      isMonth: true
    });
    this.resetFilter();
  }
  setYear(day: string): void {
    this.day = day;
    const today = moment(); // Get current date
    const startOfMonth = today.startOf('year').format('YYYY-MM-DD'); // Start of current month
    const endOfMonth = today.endOf('year').format('YYYY-MM-DD'); // End of current month
    this.from.setValue(startOfMonth);
    this.to.setValue(endOfMonth);
    this.filterForm.patchValue({
      from: startOfMonth,
      to: endOfMonth,
      isMonth: false
    });
    this.resetFilter();
  }
  formSubmit(): void {
    this.filterDate.emit(this.filterForm.value);
  }

  resetFilter(): void {
    this.filterForm.patchValue({
      from: '',
      to: ''
    });
    this.from.setValue(null);
    this.to.setValue(null);
    this.filterDate.emit(this.filterForm.value);
  }


  onMonthSelected(event: any, datepicker: MatDatepicker<any>, type: any): void {
    const selectedDate = event as Date;
    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();

    // Close the datepicker after month and year selection
    if (datepicker) {
      datepicker.close();
    }

    if (this.day === 'month' && type === 'from') {
      this.from.setValue(selectedDate);
      this.to.setValue(null);
    } else {
      this.to.setValue(selectedDate);
    }
    /* when the user selects a month for the 'to' datepicker, it should be the last day of the month*/
    if (type === 'to') {
      const lastDayOfMonth = moment().year(selectedYear).month(selectedMonth).endOf('month').toDate();
      this.to.setValue(lastDayOfMonth);
    }
  }

  onYearSelected(event: any, datepicker: MatDatepicker<any>, type: any): void {

    const selectedDate = event as unknown as Date;
    // Check if the selected date contains only the year component
    if (!isNaN(selectedDate.getTime()) && selectedDate.getMonth() === 0 && selectedDate.getDate() === 1) {

      // Close the datepicker after year selection
      if (datepicker) {
        datepicker.close();
      }

      if (this.day === 'year' && type === 'from') {
        this.from.setValue(selectedDate);
        this.to.setValue(null);
      } else {
        this.to.setValue(selectedDate);
      }
      // Set the last day of the selected year for the 'to' datepicker
      if (type === 'to') {
        const lastDayOfYear = moment(selectedDate).endOf('year').toDate();
        this.to.setValue(lastDayOfYear);
      }
    }
  }
}
